import { UserOutlined } from '@ant-design/icons';
import { CalendarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
const PostCard = ({ post }) => {
  const navigate = useNavigate();

  // PNG/JPG uzantılarını WebP'ye çevir
  const getWebPImage = (imagePath: string) => {
    if (!imagePath) return '';
    return imagePath.replace(/\.(png|jpg|jpeg|gif)$/i, '.webp');
  };

  // Blog detay sayfasına yönlendirme - slug varsa slug kullan, yoksa ID
  const handleClick = () => {
    const urlPath = post?.slug ? `/blog/${post.slug}` : `/blog/${post._id}`;
    navigate(urlPath);
  };

  return (<>
    <div
      key={post._id} onClick={handleClick}
      className='cursor-pointer w-full sm:w-[49%] md:w-[49%] lg:w-[32%] xl:w-[23%] 2xl:w-[18%] min-w-52 min-h-[376px]  border rounded-md bg-white hover:shadow-lg transition-shadow duration-300 flex flex-col gap-4 pb-4 overflow-hidden'>
      <div className='w-full flex justify-center'>
        <img src={getWebPImage(post?.blogImage)} alt={post?.title} className='w-full h-40 object-cover rounded-t-lg' />
      </div>
      <div className='w-full flex flex-col items-center justify-between gap-4 min-h-[182px]'>
        <div className='flex flex-col items-center gap-4 text-center'>
          <div className='font-bold text-lg text-gray-800 line-clamp-2 px-2'>{post.title}</div>
          <div className='text-sm text-gray-600 line-clamp-3 px-2'>{post.shortDescription}</div>
        </div>
        <div className='flex items-center gap-2 text-gray-700 text-xs bg-gray-100 px-2 py-1 rounded border border-gray-200'>
          <UserOutlined /> {post?.user} - <CalendarOutlined /> {post?.date?.substring(0, 10)}
        </div>
      </div>
    </div>
  </>

  );
};

export default PostCard